import React from 'react';
import { cn } from '~/lib/utils';
import { kitThemeClass } from './theme';
import styles from './KitChip.module.css';
import type { HeaderTheme } from './theme';
import { useV15Theme } from '~/design-system/components/v1_5/theme-context';

export interface KitChipProps {
  /** Printed verbatim. `Default`, `On dark`, `#C2410C`. */
  children: React.ReactNode;
  /**
   * Which surface the chip is sitting on.
   *
   * - `plate` (default) — on the app's own chrome. Follows the theme.
   * - `scrim` — on one of the kit's colours. Does NOT follow the theme, because the pixel
   *   underneath is the user's and does not change when the app's does.
   */
  tone?: 'plate' | 'scrim';
  theme?: HeaderTheme;
  className?: string;
}

/**
 * A small label that names something without being it.
 *
 * There is exactly one of these in the design and it appears eighteen times: the `Default` badge on
 * a kit, the four section names in the overview quilt, the three logo variation names, the seven
 * colour roles, and the format and hex tags that sit on the colours themselves. Two tones, and the
 * difference between them is which surface the chip has to survive — see `KitChip.module.css`.
 */
export function KitChip({ children, tone = 'plate', theme: themeProp, className }: KitChipProps) {
  const theme = useV15Theme(themeProp);
  return (
    <span className={cn(kitThemeClass(theme), styles.chip, tone === 'scrim' && styles.scrim, className)}>
      {children}
    </span>
  );
}
